import React from "react";
// react component for creating beautiful carousel
import Carousel from "react-slick";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import classNames from "classnames";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";

import carouselStyle from "assets/jss/material-kit-pro-react/views/componentsSections/carouselStyle.js";

import banner1 from "assets/images/banner/b1.jpg";
import banner2 from "assets/images/banner/b2.jpg";
import banner3 from "assets/images/banner/b3.jpg";
import banner4 from "assets/images/banner/b4.jpg";
import { LocationOn } from "@material-ui/icons";

const useStyles = makeStyles(carouselStyle);

export default function SectionCarousel() {
	const classes = useStyles();
	const settings = {
		dots: true,
		infinite: true,
		speed: 1000,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
	};
	return (
		<div className={classes.section} id="carousel">
			<GridContainer>
				<GridItem xs={12} sm={10} md={12} className={classes.marginAuto}>
					<div className={classes.carouselCard}>
						<Carousel {...settings}>
							<div className={classes.slide} id="carousel">
								<img
									src={"/assets/images/landing/banner/cloudbanner.jpg"}
									alt="First slide"
									className={classNames("slick-image", classes.slideImage)}
								/>
							</div>
						</Carousel>
					</div>
				</GridItem>
			</GridContainer>
		</div>
	);
}
